export type MenuBackgroundColor = 'black' | 'transparent' | 'white' | 'green';
export type MenuTextColor = 'black' | 'white' | 'green';

export interface MenuStyling {
    backgroundColor?: MenuBackgroundColor;
    textColor?: MenuTextColor;
}

/**
 * Per-page menu styling from Sanity (page.menuStyling). Null means no override:
 * the header falls back to its default styling. Set by the Pagebuilder once the
 * Sanity page is fetched, cleared on every navigation by menu-styling.global.ts.
 */
export default function useMenuStyling() {
    return useState<MenuStyling | null>('menuStyling', () => null);
}
